import React, { useState, useEffect } from 'react';
import {useNavigate,Link} from 'react-router-dom';

const Home = () => {
    const navigate = useNavigate();
    // 1. Theme State: localStorage se initial theme load karein ya default 'dark' set karein
    const [theme, setTheme] = useState(
        localStorage.getItem('theme') || 'dark'
    );

    // 2. Toggle Function
    const toggleTheme = () => {
        const newTheme = theme === 'dark' ? 'Light' : 'dark';
        setTheme(newTheme);
    };

    // 3. Effect Hook: Jab theme state badalta hai, body attribute aur localStorage update karein
    useEffect(() => {
        // Body tag par data-theme attribute set karein
        document.body.setAttribute('data-theme', theme);
        // Preference ko save karein
        localStorage.setItem('theme', theme);
    }, [theme]); // theme state badalne par chalta hai

  return (
    <>
      {" "}
      <div className="home-container">
        {/* Navigation Bar */}
    
        <nav className="navbar navbar-expand-lg navbar-dark sticky-top navbar-custom">
          <div className="container">
            <a className="navbar-brand text-white fw-bold fs-5" href="#">
                            <img src="https://deepmindinfotech.com/assets/img/logo.png" alt="logo" style={{height: '40px', marginRight: '10px'}} />

              {/* <i className="fas fa-triangle me-2 text-purple"></i> Trade
              <span className="fw-light">Street</span> */}
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                      <li className="nav-item">
                  <a
                    className="nav-link text-white px-lg-3"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      document
                        .getElementById("why-choose")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                   Why Choose
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-white px-lg-3"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      document
                        .getElementById("features")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    Features
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-white px-lg-3"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      document
                        .getElementById("pricing")
                        ?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    Pricing
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link text-white px-lg-3" href="#">
                    Guide
                  </a>
                </li>
                {/* <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle text-white" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Resources</a>
                                <ul className="dropdown-menu dropdown-menu-dark">
                                    <li><a className="dropdown-item" href="#">Tutorials</a></li>
                                    <li><a className="dropdown-item" href="#">FAQ</a></li>
                                </ul>
                            </li>
                            <li className="nav-item"><a className="nav-link text-white" href="#">Contact</a></li> */}
                        </ul>
                             {/* <button
                        className="btn btn-sm btn-neon btn-primary ms-lg-3 me-2"
                        onClick={toggleTheme}
                        aria-label={`Switch to ${theme === 'dark' ? 'Light' : 'dark'} mode`}
                        style={{ padding: '0.4rem 0.8rem', width: 'auto' }}
                    >
                        {theme === 'dark' ? (
                            <i className="fas fa-sun text-warning"></i>
                        ) : (
                            <i className="fas fa-moon text-primary"></i> 
                        )}
                    </button> */}
                        {/* <a href="#" className="btn btn-neon btn-primary ms-lg-3" onClick={() => navigate("/#/login")}>Login</a>
                         */}
                         <Link to="/login" className="btn btn-neon btn-primary ms-lg-3">Login/Sign In</Link>
                    </div>
                </div>
            </nav>

        {/* Hero Section */}
        <section
          className="hero-section text-center sale-banner"
          style={{
            backgroundImage: "url('/assets/images/download-trade.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="hero-bg-shape shape-1"></div>
          <div className="hero-bg-shape shape-2"></div>
          <div className="hero-bg-shape shape-3"></div>
          <div className="hero-bg-shape shape-4"></div>

          <div className="container position-relative z-1">
            {" "}
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h1 className="header-title text-uppercase mb-3">
                  Build confidence <br /> with every single trade
                </h1>
                <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center">
                  <a
                    href="#"
                    className="btn btn-neon btn-primary fs-5 me-sm-3 mb-3 mb-sm-0"
                  >
                    Start now for $0
                  </a>
          
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Header / Stats Section */}
        {/* <header className="text-start py-5">
                <div className="container py-5">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-5 mb-lg-0">
                            <h1 className="header-title text-uppercase mb-3">
                                TRADE <br /> SMARTER
                            </h1>
                        </div>
                        <div className="col-lg-6 ps-lg-5">
                            <div className="mb-4">
                                <h2 className="display-4 fw-bolder text-white">10,000+</h2>
                                <p className="fs-5 text-purple fw-semibold">Verified Users</p>
                            </div>
                            <div className="mb-4">
                                <h2 className="display-4 fw-bolder text-white">35+</h2>
                                <p className="fs-5 text-purple fw-semibold">Premium Features</p>
                            </div>
                            <a href="#" className="btn btn-neon btn-primary btn-lg mt-4">GET ACCESS NOW</a>
                        </div>
                    </div>
                </div>
            </header> */}

        {/* Why Choose SMRT Algo Section */}
        <section className="py-5" id="why-choose">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <h2 className="feature-heading mb-4 fw-bolder">
                  Why Choose <span className="text-purple">Trade Street</span>?
                </h2>
                <p className="fs-5">
                  Discover advanced trading signals withTrade Street's
                  cutting-edge tools, engineered for accuracy and to tackle
                  market challenges.
                </p>
                <p className="mb-4">
                  Our versatile technology supports all assets in TradingView's
                  library on any device, analyzing real-time data in seconds.
                </p>
                <a href="#" className="btn btn-neon btn-primary mt-3">
                  Get Access
                </a>
              </div>
              <div className="col-lg-6">
                <div className="chart-placeholder  text-center">
                  {/* <i className="fas fa-chart-area fa-3x text-muted opacity-50"></i> */}
                  <video
                    src="https://smrtalgo.com/wp-content/uploads/2024/07/playback-1.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-100 rounded shadow-sm"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Included Items Section */}
        <section className="bg-darker" id="features">
          <div className="container">
            <p className="text-center text-purple fw-bold mb-1">
              WHAT'S INCLUDED
            </p>
            <h2 className="text-center mb-5 fw-bolder">
              Items You Will <span className="text-purple">Get</span>
            </h2>
            <div className="row g-4">
              <div className="col-lg-3 col-md-6">
                <div className="smrt-card text-center">
                  <i className="fas fa-chart-line fa-3x text-purple mb-3"></i>
                  <h5 className="text-white">Trade Street Indicator</h5>
                  <p className="small m-0">
                    The core engine providing Buy/Sell signals and key zones.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="smrt-card text-center">
                  <i className="fab fa-discord fa-3x text-purple mb-3"></i>
                  <h5 className="text-white">Private  Access</h5>
                  <p className="small m-0">
                    The community hub for support, education, and trade ideas.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="smrt-card text-center">
                  <i className="fas fa-book-open fa-3x text-purple mb-3"></i>
                  <h5 className="text-white">Training Videos</h5>
                  <p className="small m-0">
                    Exclusive tutorials on how to set up and master the
                    indicator.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="smrt-card text-center">
                  <i className="fas fa-headset fa-3x text-purple mb-3"></i>
                  <h5 className="text-white">24/7 Premium Support</h5>
                  <p className="small m-0">
                    Dedicated team ready to help you optimize your trading.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing Section */}
        <section id="pricing" className="py-5">
          <div className="container">
            <p className="text-center text-purple fw-bold mb-1">OUR PLANS</p>
            <h2 className="text-center mb-5 fw-bolder">
              Get Instant <span className="text-purple">Access</span> Today
            </h2>
            <div className="row g-4 justify-content-center">
              {/* Monthly Plan */}
              <div className="col-lg-4 col-md-6">
                <div className="smrt-card text-center">
                  <h3 className="text-purple h5">MONTHLY ACCESS</h3>
                  <p className="display-6 fw-bold text-white my-3">
                    $99<span className="fs-6 fw-normal text-muted">/month</span>
                  </p>
                  <p className="text-muted small mb-4">
                    Commitment-free trading power.
                  </p>
                  <a href="#" className="btn btn-neon btn-primary w-100 mb-3">
                    Start Now
                  </a>
                  <ul className="list-unstyled text-start small mt-4 ps-3">
                    <li>
                      <i className="fas fa-check text-purple me-2"></i> Full
                      Indicator Suite
                    </li>
                    <li>
                      <i className="fas fa-check text-purple me-2"></i> Private
                      Discord Access
                    </li>
                    <li>
                      <i className="fas fa-times text-danger me-2"></i> Limited
                      Support
                    </li>
                  </ul>
                </div>
              </div>

              {/* Lifetime Plan (Most Popular) */}
              <div className="col-lg-4 col-md-6">
                <div className="smrt-card text-center border border-5 popular-plan">
                  <span className="badge most-popular-badge">MOST POPULAR</span>
                  <h3 className="text-purple h5 mt-2">LIFETIME ACCESS</h3>
                  <p className="display-6 fw-bold text-white my-3">
                    $999
                    <span className="fs-6 fw-normal text-muted">/one-time</span>
                  </p>
                  <p className="text-muted small mb-4">
                    One payment, trading forever.
                  </p>
                  <a href="#" className="btn btn-neon btn-primary btn-lg w-100 mb-3">
                    Get Lifetime Access
                  </a>
                  <ul className="list-unstyled text-start small mt-4 ps-3">
                    <li>
                      <i className="fas fa-check text-purple me-2"></i> Full
                      Indicator Suite (Lifetime)
                    </li>
                    <li>
                      <i className="fas fa-check text-purple me-2"></i> Private
                      Discord Access (Lifetime)
                    </li>
                    <li>
                      <i className="fas fa-check text-purple me-2"></i> Premium
                      24/7 Support
                    </li>
                    <li>
                      <i className="fas fa-check text-purple me-2"></i> All
                      Future Updates Included
                    </li>
                  </ul>
                </div>
              </div>

              {/* Quarterly Plan */}
              <div className="col-lg-4 col-md-6">
                <div className="smrt-card text-center">
                  <h3 className="text-purple h5">QUARTERLY ACCESS</h3>
                  <p className="display-6 fw-bold text-white my-3">
                    $199
                    <span className="fs-6 fw-normal text-muted">/3 months</span>
                  </p>
                  <p className="text-muted small mb-4">
                    Best value for long-term users.
                  </p>
                  <a href="#" className="btn btn-neon btn-primary w-100 mb-3">
                    Subscribe Now
                  </a>
                  <ul className="list-unstyled text-start small mt-4 ps-3">
                    <li>
                      <i className="fas fa-check text-purple me-2"></i> Full
                      Indicator Suite
                    </li>
                    <li>
                      <i className="fas fa-check text-purple me-2"></i> Private
                      Discord Access
                    </li>
                    <li>
                      <i className="fas fa-check text-purple me-2"></i> Standard
                      Support
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="bg-darker">
          <div className="container" style={{ maxWidth: "800px" }}>
            <p className="text-center text-purple fw-bold mb-1">FAQ</p>
            <h2 className="text-center mb-5">
              Frequently Asked <span className="text-purple">Questions</span>
            </h2>

            <div className="accordion" id="faqAccordion">
              {/* FAQ Item 1 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    How do I get access to the indicator?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    After purchase, you will receive an email asking for your
                    TradingView username. We will then grant you access, and the
                    indicator will appear in your "Invite-Only Scripts" section.
                  </div>
                </div>
              </div>

              {/* FAQ Item 2 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Does this work on mobile and all markets?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    Yes! Since the indicator runs on TradingView, it works
                    flawlessly on any device (desktop, laptop, mobile app) and
                    can be used to analyze Crypto, Stocks, Forex, Futures, and
                    more.
                  </div>
                </div>
              </div>

              {/* FAQ Item 3 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    What if I need help setting it up?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    Every plan includes access to our private Discord server
                    where you can find detailed video tutorials, guides, and
                    receive 24/7 support from our dedicated team.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Discord CTA Section */}
        {/* <section className="text-center py-5">
          <div className="container">
            <h2 className="mb-4">
              Join us on <span className="text-purple">Discord</span>{" "}
              <i className="fab fa-discord"></i>
            </h2>
            <a href="#" className="btn btn-neon btn-primary btn-lg">
              <i className="fab fa-discord me-2"></i> JOIN NOW
            </a>
            <p className="text-muted small mt-3">
              Over 15,000 traders active daily.
            </p>
          </div>
        </section> */}

        {/* Footer */}
        <footer
          className="smrt-footer bg-darker pt-5 pb-3 border-top"
          style={{ borderColor: "rgba(255, 255, 255, 0.1)" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-4 mb-4">
                <h5 className="fw-bold">
                  <span className="text-purple">TRADE</span> Street
                </h5>
                <p className="small">
                  © 2024 Trade Street. All Rights Reserved.
                </p>
              </div>

              <div className="col-6 col-lg-2 mb-4">
                <h6 className="text-white mb-3">QUICK LINKS</h6>
                <ul className="list-unstyled small">
                  <li>
                    <a href="#">Home</a>
                  </li>
                  <li>
                    <a href="#pricing">Pricing</a>
                  </li>
                  <li>
                    <a href="#">FAQ</a>
                  </li>
                </ul>
              </div>

              <div className="col-6 col-lg-2 mb-4">
                <h6 className="text-white mb-3">LEGAL</h6>
                <ul className="list-unstyled small">
                  <li>
                    <a href="#">Terms & Conditions</a>
                  </li>
                  <li>
                    <a href="#">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="#">Refund Policy</a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-4 mb-4">
                <h6 className="text-white mb-3">CONTACT US</h6>
                <p className="small">
                  Need support?  email us.
                </p>
                <div className="d-flex justify-content-start">
                  <a href="#" className="text-purple me-3">
                    <i className="fab fa-discord fa-2x"></i>
                  </a>
                  <a href="#" className="text-purple me-3">
                    <i className="fab fa-twitter fa-2x"></i>
                  </a>
                  <a href="#" className="text-purple">
                    <i className="fab fa-telegram-plane fa-2x"></i>
                  </a>
                </div>
              </div>
            </div>
            <div
              className="text-center small pt-3 border-top mt-3"
              style={{ borderColor: "rgba(255, 255, 255, 0.1)" }}
            >
              <p className="text-muted">
                Disclaimer: Trading is risky. Past performance is not indicative
                of future results.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Home;
  